import { render, staticRenderFns } from "./PluginSettingsStarPrinter.vue?vue&type=template&id=33d3d640&"
import script from "./PluginSettingsStarPrinter.vue?vue&type=script&lang=ts&"
export * from "./PluginSettingsStarPrinter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports